
<template>
  <div class="apply_box">
    <div class="header"
         v-if="status == '1'">
      <div class="succ_bg"></div>
      <p class="title">恭喜您的订单已提交成功</p>
    </div>
    <div class="header"
         v-else>
      <div class="fail_bg"></div>
      <p class="title">抱歉您的资质不符合产品的申请条件</p>
    </div>
    <div class="bg"></div>
    <LoanList :orderList="orderList"
              :orderTitleJson="orderTitleJson" />
  </div>
</template>

<script>
import LoanList from '@/components/loanList';
export default {
  components: {
    LoanList,
  },
  data () {
    return {
      status: '',//失败成功的标志
      orderId: '',
      orderList: [],
      orderTitleJson: {},
    }
  },
  mounted () {
    this.status = this.$route.query.status;
    this.orderId = this.$route.query.orderId;
    if (this.status == '1') {
      this.util.title('申请成功');
    } else {
      this.util.title('申请失败');
    }
    // if (window.history && window.history.pushState) {
    //   history.pushState(null, null, document.URL);
    //   window.addEventListener('popstate', this.goBack, false);
    // }
    this.getDetails();
  },
  // destroyed () {
  //   window.removeEventListener('popstate', this.goBack, false);
  // },
  methods: {
    // goBack () {
    //   // 去返回
    //   this.goHome();//回到首页
    // },
    // //跳转客户端
    // goHome () {
    //   let json = {
    //   }
    //   try {
    //     window.webkit.messageHandlers.goHome.postMessage(json);//ios
    //   } catch (err) {
    //     window.AppJs.goHome();//android
    //   }
    // },
    getDetails () {
      let param = {
        orderId: this.orderId
      }
      let _this = this;
      this.$get('/app/api/v1/order/details', param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            e.data.appOrderCells.map(function (item) {
              if (item.type == "product") {
                _this.orderList = item.content//产品列表
                _this.orderTitleJson = item.head;
              }
            })
          }
          else {
            _this.util.toast({ msg: e.msg })
          }
        })
        .catch(error => { });
    },
  }

}
</script>
<style scoped>
.apply_box {
  background: #ffffff;
}
.bg {
  background: #f7f7f7;
  width: 100%;
  height: 0.1rem;
}
.header {
  padding: 0.26rem 0 0.33rem 0;
  /* margin-bottom: 0.1rem; */
  background: #ffffff;
}
.succ_bg,
.fail_bg {
  width: 0.7rem;
  height: 0.7rem;
  background: url("../../assets/img/afterLoan/apply_success.png") no-repeat top
    center;
  background-size: 100% 100%;
  margin: 0 auto;
}
.fail_bg {
  background: url("../../assets/img/afterLoan/apply_fail.png") no-repeat top
    center;
  background-size: 100% 100%;
}
.title {
  color: #333;
  font-size: 0.16rem;
  text-align: center;
}
</style>
